export default __webpack_public_path__ + "b4f325b7f826120775e91accf25cfd87.png";